/* eslint-disable camelcase */
import axios from 'axios';

export default {

  async checkEmail(email) {
    return axios.post('/oauth/checkemail', {
      email,
    });
  },

  async login(email, password) {
    return axios.post('/oauth/login', {
      email,
      password,
    });
  },

  async generateCode(email, scope, reset, secured = false) {
    return axios.post('/oauth/generatecode', {
      email,
      scope,
      reset,
      secured,
    });
  },

  async verifyCode(email, code) {
    return axios.post('/oauth/verifycode', {
      email,
      code,
    });
  },

  async changePassword(email, new_password, new_password_confirmation, code) {
    return axios.post('/oauth/changepassword', {
      email,
      new_password,
      new_password_confirmation,
      code,
    });
  },

  async register(email, new_password, new_password_confirmation, code) {
    return axios.post('/oauth/register', {
      email,
      new_password,
      new_password_confirmation,
      code,
    });
  },

};
